export const emptyListResponse = {
    results: [],
    pagination: {
        total: 0,
        num_pages: 0,
        page: 0,
        numPages: 0
    },
}